import { supabase } from "../../shared/infrastructure/supabase";
import { FuneralHome } from "../domain/FuneralHome";
import { FuneralHomeRepository } from "../domain/FuneralHomeRepository";

export class FuneralHomeRepositorySupabase implements FuneralHomeRepository {
  async findByProperty(propertyId: string): Promise<FuneralHome[]> {
    const { data, error } = await supabase
      .from("funeral_homes")
      .select("*")
      .eq("property_id", propertyId)
      .order("name");

    if (error) {
      console.error("Error fetching funeral homes", error);
      return [];
    }

    return data.map((fh) => FuneralHome.of(fh));
  }
}
